module.exports = __webpack_public_path__ + "static/img/Fall.ffdaf53e.svg";